<div class="flex flex-col h-full">
  <div class="p-4 md:p-6 space-y-4">
    <!-- Load Info Card -->
    <div class="bg-surface-high border border-border rounded-lg p-4 flex items-start gap-3">
      <lucide-icon name="trash-2" class="w-5 h-5 text-danger mt-0.5 shrink-0"></lucide-icon>
      <div class="min-w-0 flex-1">
        <div class="flex items-center justify-between gap-2">
          <app-text weight="bold" class="text-foreground block truncate">
            Load #{{ loadSnapshot?.externalId || (loadSnapshot?.loadId | slice:0:8) }}
          </app-text>
          <span class="text-sm font-bold text-foreground">
            {{ (loadSnapshot?.pricing?.total || 0) | currency }}
          </span>
        </div>
        <app-text variant="muted" size="xs" class="block mt-0.5">
          {{ loadSnapshot?.counterpartyName || '—' }} &middot; Invoice #{{ invoice?.invoiceNumber }}
        </app-text>
      </div>
    </div>

    <!-- Question & Routing Choice -->
    <div class="space-y-3">
      <app-text size="sm" weight="medium" class="text-foreground block">
        Where should this load be routed after removal?
      </app-text>

      <div class="space-y-2">
        <label
          class="flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors"
          [class]="returnToReady() ? 'border-primary bg-primary/5' : 'border-border bg-surface hover:bg-surface-high'"
          (click)="returnToReady.set(true)"
        >
          <input
            type="radio"
            name="loadRouting"
            [checked]="returnToReady()"
            class="mt-1"
          />
          <div>
            <app-text size="sm" weight="semibold" class="text-foreground block">
              Return to Ready to Invoice
            </app-text>
            <app-text size="xs" variant="muted" class="block">
              Release the load back into the unbilled queue so it can be re-invoiced with another invoice later.
            </app-text>
          </div>
        </label>

        <label
          class="flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors"
          [class]="!returnToReady() ? 'border-primary bg-primary/5' : 'border-border bg-surface hover:bg-surface-high'"
          (click)="returnToReady.set(false)"
        >
          <input
            type="radio"
            name="loadRouting"
            [checked]="!returnToReady()"
            class="mt-1"
          />
          <div>
            <app-text size="sm" weight="semibold" class="text-foreground block">
              Mark as Do Not Invoice
            </app-text>
            <app-text size="xs" variant="muted" class="block">
              Exclude this load from invoicing permanently (sets billing status to N/A).
            </app-text>
          </div>
        </label>
      </div>
    </div>

    <!-- Reason Field -->
    <app-form-field
      label="Reason for Removal"
      hint="Optional note explaining why this load was removed from the invoice"
    >
      <app-input
        type="text"
        placeholder="e.g. Disputed rate confirmation / Invoicing separately / Load cancelled"
        [ngModel]="reason()"
        (ngModelChange)="reason.set($event)"
      ></app-input>
    </app-form-field>

    <!-- Email Notification Checkbox -->
    @if (recipientEmail()) {
      <div class="p-3 bg-surface rounded-lg border border-border flex items-start gap-2.5">
        <app-checkbox
          [ngModel]="sendUpdatedEmail()"
          (ngModelChange)="sendUpdatedEmail.set($event)"
          class="mt-0.5"
        ></app-checkbox>
        <div class="text-xs">
          <span class="font-medium text-foreground block">Email updated invoice package to recipient</span>
          <span class="text-muted block mt-0.5">
            Will reply directly to the email thread with an updated Invoice Summary Sheet and change summary.
          </span>
        </div>
      </div>
    }
  </div>

  <!-- Modal Actions -->
  <div class="mt-auto p-4 md:p-6 pt-3 flex justify-end gap-3 border-t border-border bg-surface">
    <app-button variant="ghost" (click)="close()" [disabled]="isRemoving()">
      Cancel
    </app-button>
    <app-button
      variant="danger"
      icon="trash-2"
      (click)="confirmRemove()"
      [loading]="isRemoving()"
      [disabled]="isRemoving()"
    >
      Remove Load
    </app-button>
  </div>
</div>
